import React, { Component, createRef } from "react";

class FilePicker extends Component {
  inputRef = createRef();

  static defaultProps = {
    multiple: false,
    acceptExtensions: [],
  };

  handleClick = () => {
    this.inputRef.current.click();
  };

  handleChange = (event) => {
    const { acceptExtensions = [], onFilesSelected, onError, sizeLimit = 3 } = this.props;
    const files = event.target.files;
    if (!files) return;

    let validFiles = Array.from(files);

    if (acceptExtensions && acceptExtensions.length > 0) {
      validFiles = validFiles.filter((file) => {
        const ext = "." + file.name.split(".").pop().toLowerCase();
        return acceptExtensions.includes(ext);
      });
    }

    if (validFiles.length !== files.length) {
      onError(`Solo se permiten archivos con las siguientes extensiones: ${acceptExtensions.join(',')}`);
      return;
    }

    for (const file of validFiles) {
      if (file.size > sizeLimit * 1024 * 1024) {
        onError(`El archivo ${file.name} excede el límite de tamaño de ${sizeLimit}MB.`);
        return;
      }
    }

    if (typeof onFilesSelected === "function") {
      onFilesSelected(validFiles);
    }

    event.target.value = "";
  };

  render() {
    const { children, multiple, acceptExtensions } = this.props;

    return (
      <>
        <div onClick={this.handleClick} style={{ display: "inline-block" }}>
          {children}
        </div>

        <input
          ref={this.inputRef}
          type="file"
          style={{ display: "none" }}
          multiple={multiple}
          accept={acceptExtensions.join(",")}
          onChange={this.handleChange}
        />
      </>
    );
  }
}

export default FilePicker;
